var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
function getStickyProps(stickyProp) {
    if (stickyProp.isSticky) {
        return {
            isSticky: true,
            headerHeight: stickyProp.headerHeight,
            sidebarWidth: stickyProp.sidebarWidth,
        };
    }
    return { isSticky: false, headerHeight: 0, sidebarWidth: 0 };
}
var Header = function (props) {
    var _a = props.sticky, sticky = _a === void 0 ? { isSticky: false } : _a, timebar = props.timebar;
    var _b = getStickyProps(sticky), headerHeight = _b.headerHeight, isSticky = _b.isSticky, sidebarWidth = _b.sidebarWidth;
    return (_jsx("div", __assign({ style: isSticky ? { paddingTop: headerHeight } : {} }, { children: _jsx("div", __assign({ className: "rt-sidebar__header ".concat(isSticky ? 'rt-is-sticky' : ''), style: isSticky ? { width: sidebarWidth } : {} }, { children: timebar.map(function (_a) {
                var id = _a.id, title = _a.title;
                return (_jsx("div", __assign({ className: "rt-timebar-key" }, { children: title }), id));
            }) })) })));
};
export default Header;
